import Image from "@tiptap/extension-image";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ImageNodeViewWrapper } from "../tiptapwrappers/ImageNodeViewWrapper";

export const CustomImageExtension = Image.extend({
	addNodeView() {
		return ReactNodeViewRenderer(ImageNodeViewWrapper);
	},
});
